import { FontIcon } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/components/Spinner';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, DropdownMenuItemType, IDropdown, IDropdownOption, ResponsiveMode } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Label } from 'reactstrap';
import XRegExp from 'xregexp';
import { IModalDialog } from '../../models/IModalDialog';
import "./captcha.css";
import { IRegisterProps } from './IRegisterProps';
import { IRegisterState } from './IRegisterState';
initializeIcons();

const getStyles = () => {
    return {
        root: {
            maxWidth: '300px',
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "13px", color: '#005269'
});
const topMsgPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
const leftPanel = mergeStyles({
    paddingLeft: "10px", paddingTop: "10px", width: "50%", display: "inline-block", verticalAlign: "top"
});
const rightPanel = mergeStyles({
    padding: "10px", width: "50%", display: "inline-block"
});
const errorMsgPanel = mergeStyles({
    color: '#be262c', fontSize: "12px", fontWeight: "400"
});
const iconPanel = mergeStyles({
    paddingRight: "3px"
});
const topPanel = mergeStyles({
    paddingLeft: "10px", paddingTop: "10px", width: "100%", fontWeight: "bold"
});
const captchPanel = mergeStyles({
    paddingTop: "20px", overflowX: "auto", overflowY: "hidden"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
export default class Register extends React.Component<IRegisterProps, IRegisterState>{
    private ConfirmPassword: string;
    private salutationError: string;
    private FirstNameError: string;
    private LastNameError: string;
    private PhoneNumberError: string;
    private EmailError: string;
    private PasswordError: string;
    private CPasswordError: string;
    private saving: boolean = false;
    private dialog: IModalDialog;
    private recaptchaError: string;

    constructor(props: IRegisterProps, state: IRegisterState) {
        super(props);
        this.salutationError = '';
        this.ConfirmPassword = '';
        this.FirstNameError = '';
        this.LastNameError = '';
        this.PhoneNumberError = '';
        this.EmailError = '';
        this.PasswordError = '';
        this.CPasswordError = '';
        this.recaptchaError = '';

        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.state = {
            loading: false,
            userM: {
                id: undefined,
                salutation: '',
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                password: '',
                emailVerification: false,
                activationCode: '',
                captchaToken: ''
            },
            inputError: '',
            showError: false,
            Salutations: [],
            selectedSalutation: {
                key: '',
                text: ''
            },
            isValidData: false,
            referrer: false,
            hideDialog: true,
            siteKey: ""
        }
        window['getCaptchaResponse'] = this.getCaptchaResponse;
    }
    private onloadCallback() {
        try {
            if (this.state.siteKey) {
                window['grecaptcha'].render('recaptchaRegister', {
                    'sitekey': this.state.siteKey,
                    'callback': this.getCaptchaResponse,
                    'theme': 'light'
                });
            }
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    public async componentDidMount() {
        this.loadSalutations();
        await this.loadSiteKey();
        this.onloadCallback();
    }
    public render(): React.ReactElement<IRegisterProps> {
        const dropdownRef = React.createRef<IDropdown>();
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const { siteKey } = this.state;

        if (!this.saving && this.state.isValidData)
            return <Redirect to={'/'} />;

        return (
            <div className={panel}>
                <div className={topMsgPanel}>
                    <h4><FontIcon iconName="Group" className={iconPanel} />Welcome to Zacco's agent network</h4>
                </div>
                {
                    (this.saving && !this.state.siteKey) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                        </div>
                    )
                }
                {
                    <div>
                        <Dialog
                            hidden={this.state.hideDialog}
                            dialogContentProps={{
                                type: DialogType.largeHeader,
                                title: this.dialog.dialogMessage,
                            }}
                            maxWidth="1024px"
                            closeButtonAriaLabel="Close"
                        >
                            <div>
                                <div>
                                    <Label> {this.dialog.dialogBody} </Label>
                                </div>
                            </div>
                            <DialogFooter>
                                <DefaultButton onClick={this.closeModelPopUp} className={submitButton} data-automation-id="test" text="Ok" disabled={false} iconProps={{ iconName: "CheckMark" }} />
                            </DialogFooter>
                        </Dialog>

                    </div>

                }
                {
                    ((!this.saving || !this.state.isValidData) && siteKey) && (
                        <div>
                            <div className={topPanel}>Please fill the details below.</div>
                            <div className={topPanel}>
                                Provide a valid email address as you will receive a link to validate your registration with us.
                            </div>
                            <div className={leftPanel}>
                                <div>
                                    <Stack tokens={stackTokens} verticalAlign="end">
                                        <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                            <Dropdown
                                                id="ddSalutation"
                                                placeHolder="--Select--"
                                                componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                label="Salutation"
                                                options={this.state.Salutations}
                                                styles={{ dropdown: { minWidth: 150 } }}
                                                onChanged={this.onChangeSalutations.bind(this)}
                                                errorMessage={this.salutationError}
                                                selectedKey={this.state.userM.salutation}
                                            />
                                        </Stack>
                                    </Stack>
                                </div>
                                <div>
                                    <TextField label="First Name" required placeholder="First Name" styles={getStyles}
                                        maxLength={80} value={this.state.userM.firstName} onChange={this._getErrorMessageFN} errorMessage={this.FirstNameError} />
                                </div>

                                <div>
                                    <TextField id="txtLastName" label="Last Name" required placeholder="Last Name" styles={getStyles}
                                        maxLength={80} value={this.state.userM.lastName} onChange={this._getErrorMessageLN} errorMessage={this.LastNameError} />
                                </div>

                                <div>
                                    <TextField label="Phone number" required placeholder="Phone number" styles={getStyles} maxLength={15}
                                        value={this.state.userM.phoneNumber} onChange={this._getErrorMessagePN} errorMessage={this.PhoneNumberError}
                                        iconProps={{ iconName: 'Phone' }} />
                                </div>
                            </div>
                            <div className={rightPanel}>
                                <div>
                                    <TextField label="Email address" required placeholder="Email address" styles={getStyles} onBlur={this._getErrorMessageEMValid}
                                        maxLength={320} value={this.state.userM.email} onChange={this._getErrorMessageEM} errorMessage={this.EmailError}
                                        iconProps={{ iconName: 'PublicEmail' }} />
                                </div>

                                <div>
                                    <TextField label="Password" required placeholder="Password" styles={getStyles} maxLength={24} type="password" onBlur={this._getErrorMessagePSValid}
                                        value={this.state.userM.password} onChange={this._getErrorMessagePS} errorMessage={this.PasswordError}
                                        iconProps={{ iconName: 'Lock' }} />
                                </div>

                                <div>
                                    <TextField label="Confirm Password" required placeholder="Confirm Password" styles={getStyles} maxLength={24} type="password"
                                        value={this.ConfirmPassword} onChange={this._getErrorMessageCPS} errorMessage={this.CPasswordError}
                                        iconProps={{ iconName: 'Lock' }} />
                                </div>
                                <div className={captchPanel}>
                                    <div id="recaptchaRegister">
                                    </div>
                                    <div>
                                        <span className={errorMsgPanel}>{this.recaptchaError}</span>
                                    </div>
                                </div>
                                <div className={captchPanel}>If you need any help or information, please contact us at agent.network@zacco.com.</div>
                                <div>
                                    <p> <span className={errorMsgPanel}> * </span> Mandatory  <br /><PrimaryButton text="Register" onClick={this.submitForm}
                                        className={submitButton} iconProps={{ iconName: "JoinOnlineMeeting" }} />
                                        Already registered? <Link href="./User/Login/Login">Login</Link></p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private loadSiteKey = async (): Promise<void> => {
        try {
            let siteKey: string = await this.props.connectionContext.get("Register");
            this.setState((prevState: IRegisterState): IRegisterState => {
                prevState.siteKey = siteKey;
                return prevState;
            });
        } catch (exception) {
            this.setState((prevState: IRegisterState): IRegisterState => {
                prevState.isValidData = false;
                prevState.siteKey = "";
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                return prevState;
            });
        }
    }
    private getCaptchaResponse = async (token: string) => {
        if (token) {
            this.setState((prevState: IRegisterState): IRegisterState => {
                prevState.userM.captchaToken = token;
                this.recaptchaError = '';
                return prevState;
            });
        }
    }
    private _getErrorMessageFN = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.FirstNameError = 'First Name is required.';
                prevState.userM.firstName = '';
            }
            else if (!re.test(newValue)) {
                ev.preventDefault();
                this.FirstNameError = '';
            }
            else {
                this.FirstNameError = '';
                prevState.userM.firstName = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessageLN = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = value || '';
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            if (newValue.length < 1) {
                this.LastNameError = 'Last Name is required.';
                prevState.userM.lastName = '';
            }
            else if (!re.test(newValue)) {
                this.LastNameError = '';
            }
            else {
                this.LastNameError = '';
                prevState.userM.lastName = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessagePN = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = value || '';
            const re1 = /^(\(?\+?[0-9]*\)?)?[0-9\- \(\)]*$/;
            if (newValue.length < 1) {
                this.PhoneNumberError = 'Phone number is required.';
                prevState.userM.phoneNumber = '';
            }
            else if (!re1.test(newValue)) {
                this.PhoneNumberError = 'Enter a valid phone number.';
            }
            else if (re1.test(newValue) && newValue.length < 10) {
                this.PhoneNumberError = 'Enter a valid phone number.';
                prevState.userM.phoneNumber = newValue;
            }
            else {
                this.PhoneNumberError = '';
                prevState.userM.phoneNumber = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessageEMValid = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = this.state.userM.email || '';
            const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
            if (!re.test(newValue)) {
                this.EmailError = 'Enter a valid Email address';
                prevState.userM.email = newValue;
            }
            else {
                this.EmailError = '';
                prevState.userM.email = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessageEM = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = value || '';
            if (newValue.length < 1) {
                this.EmailError = 'Email address is required.';
                prevState.userM.email = '';
            }
            else {
                this.EmailError = '';
                prevState.userM.email = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessagePS = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = value || '';
            if (newValue.length < 1) {
                this.PasswordError = 'Password is required.';
                prevState.userM.password = '';
            }
            else if (newValue.length > 1 && newValue.length < 8) {
                this.PasswordError = 'Password is too short.';
                prevState.userM.password = newValue;
            }
            else {
                this.PasswordError = '';
                prevState.userM.password = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessagePSValid = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = this.state.userM.password || '';
            const re = /^[a-zA-Z0-9~!@#$%^&*()\b]+$/;
            if (!re.test(newValue)) {
                this.PasswordError = 'Allowed characters: a-z, A-Z, 0-9 and special characters like ~!@#$%^&*()';
            }
            else {
                this.PasswordError = '';
                prevState.userM.password = newValue;
            }
            return prevState;
        });
    }
    private _getErrorMessageCPS = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IRegisterState): IRegisterState => {
            let newValue = value || '';
            const re = /^[a-zA-Z0-9~!@#$%^&*()\b]+$/;
            if (newValue.length < 1) {
                this.CPasswordError = 'Confirm Password is required.';
                this.ConfirmPassword = '';
            }
            else if (newValue.length < 8) {
                this.CPasswordError = 'Confirm Password is too short.';
                this.ConfirmPassword = newValue;
            }
            else if (!re.test(newValue)) {
                this.CPasswordError = 'Allowed characters: a-z, A-Z, 0-9 and special characters like ~!@#$%^&*()';
            }
            else if (prevState.userM.password !== newValue) {
                this.CPasswordError = 'Confirm password should match with Password';
                this.ConfirmPassword = newValue;
            }
            else {
                this.CPasswordError = '';
                this.ConfirmPassword = newValue;
            }
            return prevState;
        });
    }
    private loadSalutations(): void {
        this.setState((prevState: IRegisterState): IRegisterState => {
            var result: any = [];
            result.push(
                { key: '--Select--', text: '--Select--', itemType: DropdownMenuItemType.Header },
                { key: 'Mr.', text: 'Mr.' },
                { key: 'Mrs./Ms.', text: 'Mrs./Ms.' }
            );
            prevState.Salutations = result;
            return prevState;
        });
    }
    private onChangeSalutations(item: IDropdownOption) {
        this.setState((prevState: IRegisterState): IRegisterState => {
            prevState.selectedSalutation = item;
            this.salutationError = item.text.trim().length > 0 ? '' : 'Select a Salutation';
            prevState.userM.salutation = item.key.toString();
            return prevState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            this.saving = true;

            try {
                await this.props.connectionContext.post("Register", this.state.userM);

                this.setState((prevState: IRegisterState): IRegisterState => {
                    prevState.isValidData = true;
                    prevState.hideDialog = false;
                    this.handleError("Success", "Thanks for registering with us. We have sent a verification link to your registered email address : " + this.state.userM.email.toString() + ". Please click on the link to complete the registration process.");
                    return prevState;
                });
            } catch (exception) {
                if (exception === 409) {
                    this.setState((prevState: IRegisterState): IRegisterState => {
                        prevState.isValidData = false;
                        prevState.hideDialog = false;
                        this.handleError("Warning", "Email address has already been registered with Zacco. Please use different email address.");
                        return prevState;
                    });
                } else {
                    this.setState((prevState: IRegisterState): IRegisterState => {
                        prevState.isValidData = false;
                        prevState.hideDialog = false;
                        this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                        return prevState;
                    });
                }
                this.onloadCallback();
            }
        }
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;
        let FirstNameEntered: boolean = this.state.userM.firstName.toString().trim().length > 0;
        let LastNameEntered: boolean = this.state.userM.lastName.toString().trim().length > 0;
        let PhoneNoEntered: boolean = this.state.userM.phoneNumber.toString().trim().length > 0;// && isValidPhoneNumber(this.state.userM.phoneNumber);
        let EmailEntered: boolean = this.state.userM.email.toString().trim().length > 0;
        let PasswordEntered: boolean = this.state.userM.password.toString().trim().length > 0;
        let CPasswordEntered: boolean = this.ConfirmPassword.toString().trim().length > 0;
        let PasswordMatched: boolean = this.state.userM.password.toString().trim() === this.ConfirmPassword.toString().trim();
        let captchatoken: boolean = this.state.userM.captchaToken.toString().trim().length > 0;

        if (!FirstNameEntered) {
            this.FirstNameError = 'First Name is required';
            validState = false;
        }
        if (!LastNameEntered) {
            this.LastNameError = 'Last Name is required';
            validState = false;
        }
        if (!PhoneNoEntered) {
            this.PhoneNumberError = 'Valid phone number is required';
            validState = false;
        }
        if (!EmailEntered) {
            this.EmailError = 'Email address is required';
            validState = false;
        }
        if (!PasswordEntered) {
            this.PasswordError = 'Password is required';
            validState = false;
        }
        if (!CPasswordEntered) {
            this.CPasswordError = 'Confirm password is required';
            validState = false;
        }
        if (!PasswordMatched) {
            this.CPasswordError = 'Confirm password should match with Password';
            validState = false;
        }
        if (!captchatoken) {
            this.recaptchaError = 'Invalid captcha';
            validState = false;
        }
        else {
            this.recaptchaError = '';
        }
        this.setState((prevState: IRegisterState): IRegisterState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IRegisterState): IRegisterState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IRegisterState): IRegisterState => {
            previousState.hideDialog = true;
            this.saving = false;
            return previousState;
        });
    }
}